import ProductGallery from '@/components/ProductGallery'; 
import Image from 'next/image'; 
import Link from 'next/link'; 
import {downloadLink } from '@/lib/utils.js'
import {useContext} from 'react'; 
import {CartContext} from '@/lib/cart_context.js' 
import CustomizableProductButtonArea from '@/components/customizable_product_button_area'
import CustomizableProductDescriptionArea from '@/components/customizable_product_description_area'

export default function ProductTopSection({product, primarySpecSheet, product_photo_placement, resource_display, config}) {
  const subNamePresent =  product.sub_name && product.sub_name.trim() !== ''
  const h1 = subNamePresent ? product.sub_name : product.name 
  const cart = useContext(CartContext);
  const cartActive = cart?.itemInCart
  const itemInCart = cartActive &&  cart.itemInCart(product.id); 
  const pills_present = (product.is_new || product.is_discontinued || product.is_legacy)
  const pills = <>{ product.is_new && <div className="lexcms-product-tile-new-product">New Product</div>}
    { product.is_discontinued && <div className="lexcms-product-tile-discontinued-product">Discontinued Product</div> }
    { product.is_legacy && <div className="lexcms-product-tile-legacy-product">Legacy Product</div> }</>;

  
  return  (
    <section className="lexcms-main-product-info-container">
      <div className="lexcms-product-image-carousel-container">
        <ProductGallery key={product.id} product={product} product_photo_placement={product_photo_placement} />
      </div>
      <div className="lexcms-product-details-container">
        {subNamePresent && pills_present &&
         <div className="lexcms-product-name-container lexcms-product-h2-container">
          <h2 className="lexcms-product-name">{product.name}</h2>
          {pills}
         </div>
        }
        {subNamePresent && !pills_present &&
          <h2 className="lexcms-product-name">{product.name}</h2>
        }
        { pills_present &&
          <div className="lexcms-product-name-container lexcms-product-h1-container">
            <h1 className={`lexcms-product-${subNamePresent ? 'subname' : 'name'}`}>{h1}</h1>
            {!subNamePresent &&
              pills
            }
          </div>
        }
        {!pills_present &&
          <h1 className={`lexcms-product-${subNamePresent ? 'subname' : 'name'}`}>{h1}</h1>
        }

        <CustomizableProductDescriptionArea 
          product={product}
          primarySpecSheet={primarySpecSheet}
          resource_display={resource_display}
          config={config}
          cartActive={cartActive}
          cart={cart}
          itemInCart={itemInCart}

        /> 

        <CustomizableProductButtonArea 
          product={product}
          primarySpecSheet={primarySpecSheet}
          resource_display={resource_display}
          config={config}
          cartActive={cartActive}
          cart={cart}
          itemInCart={itemInCart}
          
        /> 
        <div className="lexcms-product-certs-container">
          {product?.certifications?.map((cert, i) => { 
            return (<div key={i} className="lexcms-product-cert-image-container">
              <Image
                priority
                src={cert.url}
                height={65}
                width={65}
                alt={""}
                className="lexcms-product-cert-image"
              />
            </div>
            )
          })
          }
        </div>
      </div>
    </section>
  )
}
